/* @flow */
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/search.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import { Search } from 'semantic-ui-react'
import './identificator.css'

const municipalities = require('./data/gemeindeverzeichnis.json')
type Municipality = {
  GDENR: number,
  ORTNAME: string,
  PLZ4: number,
  GDENAMK: string,
  KTKZ: string
}
const limitedSource = municipalities
  .filter(
    (municipality: Municipality) =>
      municipality.KTKZ === 'ZH' || municipality.KTKZ === 'BE'
  )
  .map((municipality: Municipality) => {
    return {
      title: `${municipality.PLZ4} ${municipality.ORTNAME}`,
      description: `Gemeinde ${municipality.GDENAMK}`,
      gemeinde: municipality.GDENAMK,
      childKey: `${municipality.GDENR}-${municipality.PLZ4}-${
        municipality.ORTNAME
      }`,
      id: municipality.GDENR
    }
  })

type Props = {
  onSelectionHandler: () => {}
}

type State = {
  isLoading: boolean,
  results: Array<{ title: string, id: number }>,
  value: string
}

export class SearchField extends React.Component<Props, State> {
  resetComponent = () => {
    this.setState({
      isLoading: false,
      results: [],
      value: ''
    })
  }

  handleResultSelect = (event, { result }) => {
    this.setState({ value: result.title })
    this.props.onSelectionHandler(result.id)
  }

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, value: value })

    if (value.length < 1) {
      return this.resetComponent()
    }

    setTimeout(() => {
      const re = new RegExp(value, 'i')
      const isMatch = result => re.test(result.title + result.gemeinde)
      let results = limitedSource.filter(isMatch)

      this.setState({ isLoading: false, results })
    }, 300)
  }

  // region React Component Lifecycle
  componentWillMount () {
    this.resetComponent()
  }

  render () {
    const { isLoading, value, results } = this.state

    return (
      <Search
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={results}
        value={value}
        size={'large'}
        minCharacters={2}
        fluid
        noResultsMessage={
          'Es wurde keine Gemeinde mit dieser Postleitzahl gefunden'
        }
      />
    )
  }

  // endregion
}



// WEBPACK FOOTER //
// ./src/components/identificator/Identificator.js